import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Widgets from "./widgets";
import Dashboard from "./dashboard";
import Functions from "./functions";
import Apps from "./apps";
import './marketplace.scss';

export default function Marketplace() {
  return (
    <Switch>
      <Route
        exact
        path="/marketplace"
        component={() => <Redirect to="/marketplace/widgets" />}
      />
      <Route path="/marketplace/dashboard" component={Dashboard} />
      <Route path="/marketplace/widgets" component={Widgets} />
      <Route path="/marketplace/apps" component={Apps} />
      <Route path="/marketplace/functions" component={Functions} />
      <Route component={() => <Redirect to="/404"/>}/>
    </Switch>
  );
}
